<template>
  <div class="invoice-receipt-manage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          :picker-options="pickerOptions2"
          size="small"
          unlink-panels
          @change="changeTimeValue"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <button-cancel @cancel="batchMakeInvoice" value="批量开票" style="margin-left: 10px;" />
      </div>
      <input-search placeholder="费用项" @search="searchKey" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @makeInvoiceRow="showMakeInvoiceDialog" @changePagination="changePagination" @changeSelection="changeSelection" :operationArr="operationArr" />

    <el-dialog title='开票信息' :visible.sync="makeInvoiceDialogVisible" width="800px">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">发票抬头：</span>
          </div>
          <el-select v-model="buyerTitleCode" filterable remote reserve-keyword placeholder="请输入关键词" size="small" style="width: 280px" :remote-method="getInvoiceTitleList">
            <el-option v-for="item in buyerTitleList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">发票类型：</span>
          </div>
          <el-radio-group v-model="kptype" style="width: 280px">
            <el-radio label="1">正票</el-radio>
            <el-radio label="2">红票</el-radio>
          </el-radio-group>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">发票种类：</span>
          </div>
          <el-radio-group v-model="invoiceLine" style="width: 280px">
            <el-radio label="p">普票</el-radio>
            <el-radio label="s">专票</el-radio>
          </el-radio-group>
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">备注：</span>
          </div>
          <el-input v-model="message" size="small" style="width: 280px" />
        </div>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="makeInvoiceDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="openInvoice">开 票</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import InputSearch from '../../../components/Input/InputSearch'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/invoice'
  import {errorHandler} from '../../../utils/errorHandler'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {capitalAmount} from "../../../tool/tools";
  import * as Printjs from "print-js";
  import bus from "../../../utils/bus";

  export default {
    components: {
      ButtonCancel,
      ButtonConfirmNext,
      TableMain,
      InputSearch,
      Breadcrumb},
    name: 'invoice-collection-record',
    data () {
      return {
        breadcrumb: [{
          value: '智慧凭证',
          name: 'invoice-over-view'
        }, {
          value: '发票管理'
        }],
        pickerOptions2: {
          disabledDate (time) {
            return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        tableHead: [{
          prop: 'paymentItemName',
          label: '费用项',
        }, {
          prop: 'personName',
          label: '付款人',
        }, {
          prop: 'enterpriseName',
          label: '所在住户',
        }, {
          prop: 'money',
          label: '金额(元)',
        }, {
          prop: 'consumeTime',
          label: '收款时间',
        }],
        tableData: [],
        operationArr: ['makeInvoice'],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        timeValue: [],
        requestData: {
          pageNum: 1,
          pageSize: 10,
          startTime: '',
          endTime: '',
          searchKey: ''
        },
        selectionArr: [],

        buyerTitleCode: '',
        buyerTitleList: [],
        kptype: '1',
        invoiceLine: 'p',
        message: '',
        makeInvoiceData: [],
        makeInvoiceDialogVisible: false,
      }
    },
    created () {
      this.getCreatTime()
      this.getInvoiceTitleList()
    },
    mounted() {},
    methods: {
      getInvoiceTitleList (query) {
        this.$axios.post(api.getInvoiceTitleList, {
          searchKey: query
        })
          .then(res => {
            let list = res.data.data
            this.buyerTitleList = list
          })
          .catch(errorHandler('获取抬头失败'))
      },

      getCreatTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        this.timeValue[0] = year + '-' + month + '-01'
        this.timeValue[1] = year + '-' + month + '-' + date
        this.getPage()
      },
      changeTimeValue () {
        this.pageNum = 1
        this.pageSize = 10
        this.getPage()
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        if (this.timeValue.length > 0) {
          reqData.startTime = `${this.timeValue[0]} 00:00:00`
          reqData.endTime = `${this.timeValue[1]} 23:59:59`
        }
        this.$axios.post(api.getInvoicingPage, reqData)
          .then(res => {
            let list = res.data.data.list
            this.total = res.data.data.total
            list.map(v => {
              v.code = v.outTradeNo
            })
            this.tableData = list
          })
          .catch(errorHandler('获取失败'))
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },

      changeWindowLeftPagination (data) {
        this.windowLeftPageNum = data[0]
        this.windowLeftPageSize = data[1]
        this.getPageApply()
      },

      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },

      // 批量开票
      batchMakeInvoice () {
        if (this.selectionArr.length === 0) {
          nError('请先选择需要开票的记录')
          return false
        }
        let makeInvoiceData = []
        this.tableData.map(v => {
          if (this.selectionArr.indexOf(v.code) !== -1) {
            makeInvoiceData.push(v)
          }
        })
        this.makeInvoiceData = makeInvoiceData
        this.makeInvoiceDialogVisible = true
      },

      // 单开
      showMakeInvoiceDialog (data) {
        this.makeInvoiceData = [data]
        this.makeInvoiceDialogVisible = true
      },

      openInvoice () {
        let reqData = {
          buyerTitle: {},
          kptype: this.kptype,
          invoiceLine: this.invoiceLine,
          personCode: bus.global.accountCode,
          personName: bus.global.accountName,
          personPhone: '',
          message: this.message,
          consumptionDtos: this.makeInvoiceData,
        }
        reqData.consumptionDtos.map(val => {
          for (let i in val) {
            if (val[i] === '--') {
              val[i] = null
            }
          }
        })
        this.buyerTitleList.map(v => {
          if (v.code === this.buyerTitleCode) {
            reqData.buyerTitle = v
          }
        })
        this.$axios.post(api.openInvoice, reqData)
          .then(res => {
            this.makeInvoiceDialogVisible = false
            this.buyerTitleCode = ''
            this.buyerTitleList = []
            this.kptype = '1'
            this.invoiceLine = 'p'
            this.message = ''
            this.makeInvoiceData =[]
            nSuccess('开票成功')
            this.getPage()
          })
          .catch(errorHandler('开票失败'))
      }

    },
    watch: {}
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .invoice-receipt-manage {
    .el-dialog .el-dialog__body .el-table .has-gutter th:first-child {
      /*width: 50%!important;*/
    }

    .right-slide-enter,
    .right-slide-leave-active {
      transform: translateX(100%);
    }

    .right-slide-leave-active,
    .right-slide-enter-active {
      transition: all 0.3s;
    }
    .window-left-box {
      position: fixed;
      right: 0;
      top: 0;
      bottom: 0;
      width: 60%;
      z-index: 10;
    }
    .window-left-box .move-enter-active, .window-left-box .move-leave-active {
      transition: all 2s linear;
      transform: translate3d(0, 0, 0);
    }
    .window-left-box .move-enter, .window-left-box .move-leave {
      transform: translate3d(100%, 0, 0);
    }
    .window-left-main {
      width: 100%;
      height: 100%;
      z-index: 30;
      background: #FFFFFF;
      padding: 5px 10px;
      overflow: auto;
    }

    .mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      opacity: .4;
      z-index: -1;
      background-color: #000000;
      transition: opacity .5s ease;
    }

    form {
      width: 450px;
      margin: 0 auto;
      text-align: left;
    }
    .form-line {
      margin: 25px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .line-text{
      color: #48576a;
      font-size: 14px;
      margin-right: 10px;
      width: 100px;
      display: flex;
      justify-content: space-between;
    }
    .line-info {
      width: 220px;
    }
    .form-btn-box {
      width: 530px;
      padding: 0 124px;
      margin: 40px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .person-management-drawer {
      .el-icon-back {
        margin: 20px 20px 10px;
        display: block;
        border: 0;
        font-size: 20px;
        background-color: #ffffff;
        cursor: pointer;
      }
      .el-icon-back:hover {
        color: #00a0e6;
      }
      .all-table-class .el-table td {
        padding: 10px 0;
      }
      form {
        position: relative;
        .drawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
        }
        .noDrawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
          height: 150px;
          line-height: 160px;
          border: 1px dashed #dcdfe6;
          text-align: center;
          color: #999999;
        }
      }
    }
    .drawerBtnBox {
      width: 360px;
      padding-right: 60px;
      margin: 40px auto 0;
      .btn-confirm {
        border: 0;
        color: #FFF;
        padding: 8px 16px;
        background-color: #00a0e6;
        border-radius: 4px;
        margin-right: 60px;
      }
      .btn-confirm:hover {
        color: #FFF;
        background-color: #06b3ff;
      }
      .reject-button {
        border: 0;
        background-color: #f25721;
        color: #FFFFFF;
        border-radius: 4px;
      }
      .reject-button:hover {
        background-color: #F96E3D;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Invoice/InvoiceManage/InvoiceCollectionRecord.vue